<template>
    <div class="row">
        <div class="col-md-12 overflow-auto">
            <b-table :stacked="$mobile == 1" ref="table" class="vuetable" sort-by="id" sort-desc.sync="false"
                :current-page="currentPage" :fields="bootstrapTable.fields" :items="data">

                <template #cell(join_live)="row">
                    <div class="text-center">
                        <button v-if="row.item.online_session && row.item.online_session.id"
                            @click="openLive(row.item.online_session)" class="btn btn-primary btn-sm">
                            <i class="fas fa-video"></i> انضم للجلسة المباشرة
                        </button>
                        <button v-else class="btn btn-secondary btn-sm" disabled>
                            <i class="fas fa-video"></i> لا يوجد جلسة مباشرة
                        </button>
                    </div>
                </template>

                <!-- Join Recording Button -->
                <template #cell(join_recording)="row">
                    <div class="text-center">
                        <router-link v-if="row.item.online_session && row.item.online_session.id" :to="{
                            name: 'OnlineDetails',
                            params: {
                                id: row.item.online_session.id,
                            },
                        }" class="btn btn-warning btn-sm">
                            <i class="fas fa-play-circle"></i> مشاهدة التسجيل
                        </router-link>

                        <button v-else class="btn btn-secondary btn-sm" disabled>
                            <i class="fas fa-play-circle"></i> لا يوجد تسجيل
                        </button>
                    </div>
                </template>

                <!-- Completed Check Mark -->
                <template #cell(completed)="row">
                    <button class="btn btn-success btn-sm" v-if="row.item.complete == 0" @click="complete(row)"
                        :disabled="row.item.complete == 1">
                        <i class="fas fa-check"></i>
                    </button>
                    <span v-else class="text-success">
                        <i class="fas fa-check"></i>
                    </span>
                </template>


            </b-table>
            <hr />

            <b-pagination v-model="currentPage" align="right" @input="onPageChange"
                class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows"
                :per-page="perPage">
                <template v-slot:next-text>
                    <i class="fas fa-angle-left" />
                </template>
                <template v-slot:prev-text>
                    <i class="fas fa-angle-right" />
                </template>
                <template v-slot:first-text>
                    <i class="fas fa-step-forward" />
                </template>
                <template v-slot:last-text>
                    <i class="fas fa-step-backward" />
                </template>
            </b-pagination>
            <!-- end of table -->
        </div>
        <!-- end of col -->
    </div>

</template>

<script>
import controller from "@/Controllers/QuranScheduleDateController";
import OnlineSessionController from "@/Controllers/OnlineSessionController";
import Swal from 'sweetalert2'

export default {
    name: "QuranScheduleDataTablev2",
    props: ["editItem", "type"],
    async created() {
        const response = await this.controller.GetAll(this.apiParamsConverter());
        this.data = response.data;
        this.currentPage = response.current_page;
        this.perPage = response.per_page;
        this.totalRows = response.total;
        this.from = response.from;
        this.to = response.to;

        if (this.type == 'teacher') {
            this.bootstrapTable.fields.push({
                key: "completed",
                label: "مكتمل",
                sortable: false,
                thClass: "text-center",
                tdClass: "text-center",
            },);
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            controller: new controller(),
            data: [],
            currentPage: 1,
            perPage: 8,
            totalRows: 0,
            from: 0,
            to: 0,
            apiParams: {},
            bootstrapTable: {
                selected: [],
                selectMode: "multi",
                fields: [
                    {
                        key: "name",
                        label: "اسم المقرأة",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },


                    {
                        key: "alward",
                        label: "الورد",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "date",
                        label: "التاريخ",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "start",
                        label: "وقت البدء",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "end",
                        label: "وقت النهاية",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "join_live",
                        label: "الانضمام للجلسة المباشرة",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },
                    {
                        key: "join_recording",
                        label: "الانضمام للتسجيل",
                        sortable: false,
                        thClass: "text-center",
                        tdClass: "text-center",
                    },

                ],
            },
        };
    },
    methods: {
        apiParamsConverter() {
            const apiParams = { per_page: this.perPage };
            if (this.currentPage) {
                apiParams.page = this.currentPage;
            }
            apiParams.filter = "quran_program_id|" + this.$route.params.id;
            apiParams.sort = "created_at|asc";
            apiParams.with = ["onlineSession"]
            return apiParams;
        },
        onPageChange(page) {
            this.currentPage = page;
            this.dataProvider();
        },
        openLive(online_session) {
            new OnlineSessionController().joinLecture(online_session.id);
        },
        async dataProvider() {
            const response = await this.controller.GetAll(this.apiParamsConverter());
            this.data = response.data;
            this.currentPage = response.current_page;
            this.perPage = response.per_page;
            this.totalRows = response.total;
            this.from = response.from;
            this.to = response.to;
        },
        async complete(item) {
            //update all items with the same alward to complete
            const payload = {
                complete: 1,
            };
            const toUpdate = this.data.filter(i => i.alward === item.item.alward);
            //load Swal alert
            Swal.fire({
                position: 'top-end',
                icon: 'info',
                timer: 2000,
                title: "يتم التحديث",
                showConfirmButton: false,
            })
            for (const i of toUpdate) {
                await this.controller.Updata({
                    ...i,
                    ...payload,
                }, false);
            }
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'تمت العملية بنجاح',
                showConfirmButton: false,
                timer: 3000,
            })


            this.dataProvider();
        },
        async refresh() {
            await this.dataProvider();
        },
    }
}

</script>